import React, {Fragment} from 'react';
import ReactDOM from 'react-dom';
import Header from '../components/Header/Header.js';
import About from '../components/About/About.js';
import Work from '../components/Work/Work.js';
import Contact from '../components/Contact/Contact.js';
import Skills from '../components/Skills/Skills.js';
import { connect } from 'react-redux';

class HomeScreen extends React.Component {

  componentDidMount() {
    let hash = this.props.location.hash.replace('#', '');
    if (hash) {
      let node = ReactDOM.findDOMNode(this.refs[hash].getWrappedInstance() || this.refs[hash]);

      if (node) {
        node.scrollIntoView();
      }
    }
  }

  componentDidUpdate() {
  }

  render() {
    return (
      <Fragment>
        <Header ref="home" />
        <div id="page_wrap">
          <About ref="about" />
          <Skills ref="skills" />
          <Work ref="portfolio" />
          <Contact ref="contact" />
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = state => ({
  section: state.current_section
});

export default connect(mapStateToProps, null, null, {withRef: true})(HomeScreen);



// WEBPACK FOOTER //
// ./src/screens/HomeScreen.js